import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { storageSetItem, storageRemoveItem, storageGetItem } from '../utils/local-storage';
import { ACCESS_TOKEN, ACCESS_TOKEN_EXPIRY, AFFILIATE_ID, REMEMBER_AUTH, USER_PROFILE } from '../utils/storage-keys';

export const loadSession = () => {
  const sessionToken = storageGetItem(ACCESS_TOKEN);
  const sessionTokenExpiry = storageGetItem(ACCESS_TOKEN_EXPIRY);
  const remember = storageGetItem(REMEMBER_AUTH);

  if (!sessionToken) {
    return null;
  }

  if (!sessionTokenExpiry) {
    removeSessionExpired();
    return null;
  }

  if (remember !== 'forever') {
    const expiredDate = Number.parseInt(sessionTokenExpiry.toString(), 10);
    if (expiredDate <= Date.now()) {
      removeSessionExpired();
      return null;
    }
  }

  return sessionToken;
};

const removeSessionExpired = () => {
  storageRemoveItem(ACCESS_TOKEN);
  storageRemoveItem(ACCESS_TOKEN_EXPIRY);
  storageRemoveItem(AFFILIATE_ID);
  storageRemoveItem(USER_PROFILE);
  storageRemoveItem(REMEMBER_AUTH);
  window.location.href = '/affiliate-area-dashboard/login';
};

const useSession = () => {
  const [session, setSession] = useState(null);
  const [affiliateID, setAffiliateID] = useState(null);
  const navigate = useNavigate();
  const sessionToken = loadSession();

  useEffect(() => {
    setSession(sessionToken);
  }, [sessionToken]);

  const storeSession = React.useCallback((sessionToken, expiry, affiliateID, userProfile, status) => {
    if (sessionToken && affiliateID) {
      storageSetItem(ACCESS_TOKEN_EXPIRY, expiry.getTime().toString());
      if (status !== 'active') {
        navigate('/pending');
      } else {
        storageSetItem(ACCESS_TOKEN, sessionToken);
        storageSetItem(AFFILIATE_ID, affiliateID);
        storageSetItem(USER_PROFILE, userProfile);
        setSession(sessionToken);
        setAffiliateID(affiliateID);
        navigate('/');
      }
    }
  }, [navigate]);

  const signOut = () => {
    removeSessionExpired();
    setSession(null);
  };

  return {
    session,
    storeSession,
    signOut,
    affiliateID
  };
};

export default useSession;
